<template>
  <div>
    <el-select
      size="mini"
      placeholder="Tecnico Asignado"
      v-model="TechnicianId"
      filterable
      clearable
      :loading="techniciansLoading"
      :disabled="techniciansLoading"
      @change="handleTechnicianChange"
    >
      <el-option
        v-for="(item, index) in technicians"
        :key="index"
        :value="item.value"
        :label="item.label"
      />
    </el-select>
  </div>
</template>

<script>
import { formatArrayToElSelect /*, formatDate, formatQty*/ } from "@/utils";

export default {
  name: "AsignedThecnicians",

  data() {
    return {
      TechnicianId: "",
      technicians: [],
      techniciansLoading: false
    };
  },

  async mounted() {
    await this.GetTechnicians();
  },
  methods: {
    formatArrayToElSelect,
    async GetTechnicians() {
      this.techniciansLoading = true;
      await this.$http
        .get("/api/users/technicians")
        .then((resp) => {
          this.technicians = this.formatArrayToElSelect(resp.data, {
            label: "FullName",
            value: "id"
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.techniciansLoading = false;
        });
    },
    async handleTechnicianChange(technician) {
      // this.selectedTechnician = technician;
      // await this.onChangeCustomerService(this.requestType);
      this.$emit("ThecnicianChaged", technician);
    }
  }
};
</script>
